import { LocalizedTextDisplayModel } from "@/api/model-index";
import { AbschnittDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/abschnitt-display-model";
import { GlobalEnumsAceFormulartyp } from "@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-formulartyp";

export class NavigationItem {
    public id: string;
    public name: LocalizedTextDisplayModel[];
    public link: string;
    public icon: string;
    public abschnitt: AbschnittDisplayModel;
    public formularTyp?: GlobalEnumsAceFormulartyp;
    public children: NavigationItem[] | null;
    public childAbschnitte: AbschnittDisplayModel[];
}